module.exports = __webpack_public_path__ + "static/media/blackboard.3e698519.png";